export default "__VITE_ASSET__7e92ceea__"